import { apiInstance } from "@/api/api.js"
import Vue from 'vue'
const api = apiInstance()

export default {
  async getTemplates ({ commit, dispatch }, params) {
    try {
      commit('setLoading', true)
      const response = await api.get('/messages/templates', { params })
      commit('setTemplates', response.data.templates)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async getTemplate({ commit, dispatch }, id) {
    const url = `/messages/templates/${id}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      commit('headersStates/setHeadersEtag', { headers: response.headers, url }, { root: true })
      commit('setTemplate', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.name, { root: true })
      commit('setLoading', false)
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async addTemplate ({ commit, dispatch }, data) {
    try {
      commit('setLoading', true)
      const response = await api.post('/messages/templates', data)
      await dispatch('getTemplates')
      await dispatch('getTemplate', response.data.id)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'New sprint added!', { root: true })
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async duplicateTemplate ({ commit, dispatch, rootState }, templateId) {
    const url = `/messages/templates/${templateId}/duplicate`
    const templateUrl = `/messages/templates/${templateId}`
    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      const response = await api.post(url, {}, { headers: { "If-Match": headersStates.headersEtag[templateUrl] }})
      await dispatch('getTemplates')
      await dispatch('getTemplate', response.data.id)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Sprint duplicated!', { root: true })
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async deleteTemplate ({ commit, dispatch, rootState }, id) {
    const url = `/messages/templates/${id}`

    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await api.delete(url, { headers: { "If-Match": headersStates.headersEtag[url] }})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Sprint deleted!', { root: true })
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
  async changeTemplate ({ state, commit, rootState, dispatch }, { id, data }) {
    const url = `/messages/templates/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      const response = await api.put(
        url,
        data,
        { headers: { "If-Match": headersStates.headersEtag[url] }}
      )
      commit('setTemplate', response.data)
      commit('appStates/setBreadcrumbCurrentView',response.data.name, { root: true })
      commit('headersStates/setHeadersEtag', { headers: response.headers, url }, { root: true })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      await dispatch('getTemplate', id)
      commit('setLoading', false)
    }
  },
  async sharePractices ({ commit, dispatch, rootState }, {id, practices}) {
    const url = `/messages/templates/${id}`
    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      const response = await api.post(url+`/share`, {practices: practices},
        { headers: { "If-Match": headersStates.headersEtag[url] }})
      await dispatch('getTemplate', id)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Sprint shared!', { root: true })
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },

  async applyTemplateOnParticipant ({ state, commit, dispatch, rootState }, {id, templateId, startDate}) {
    const url = `/messages/templates/${templateId}`
    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await dispatch('getTemplate', templateId)
      let params = {participantProfileId: id}
      if (startDate) params.startDate = startDate
      const response = await api.post(url+'/apply', params,
      { headers: { "If-Match": headersStates.headersEtag[url] }})
      commit('headersStates/setHeadersEtag', { headers: response.headers, url }, { root: true })
      let info = ''
      if (response.data.firstMessage) info = 'Sprint applied, first message is planned to be sent on '+ Vue.moment(response.data.firstMessage.plannedSendDateLocal).format("MM/DD/YYYY, hh:mm A") + '. '
      if (response.data.messageInPast) info += 'Some messages where created with a past date and will not be sent.'
      if (info !== '') commit('appStates/setSnackbarNotification', info, { root: true })
      commit('setLoading', false)
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
      commit('setLoading', false)
    }
  },
}
